<div class="w-full" [formGroup]="formGroup()" #inputContainer>
  <div
    [class]="containerClasses()"
    [tabIndex]="-1"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="onClickElement()"
  >
    <svg-icon [src]="leftIcon()" [svgClass]="leftIconClasses()"></svg-icon>
    <input
      #input
      [tabIndex]="tabIndexInput()"
      [class]="inputClasses()"
      [formControlName]="controlName()"
      [placeholder]="placeholder()"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
    @if (
      control().value !== null &&
      control().value !== undefined &&
      control().value !== ''
    ) {
      <button
        type="button"
        [disabled]="isDisabled()"
        [tabIndex]="tabIndexRightIconButton()"
        (click)="onClickRightIcon()"
        (focus)="onFocus()"
        (blur)="onBlur()"
      >
        <svg-icon
          [src]="rightIcon()"
          [svgClass]="rightIconClasses()"
        ></svg-icon>
      </button>
    }
  </div>
  @if (message() !== '') {
    <div [class]="messageClasses()">{{ message() }}</div>
  }
</div>
